namespace advisorop.components.common {

    export class ApplicationTrackerMainController {

        // bindings
        filterByAdvisor: boolean;
        includeProposedAmount: boolean;

        dashboardLabel: string = "";

        user: domains.IUser;

        // active tab
        selTab = 0; // 1 - new account LC, 2 - goal modified

        // user filter
        selUser;

        // checkboxes
        newAccLcArchivedOnly = false;
        goalModifLcArchivedOnly = false;

        // checkboxes
        filterUnclaimedNewAcc = false;
        filterUnclaimedGoalModified = false;

        // original data arrays
        newAccountLC;
        goalModificationLC;
        // filtered data
        filteredNewAccountLC;
        filteredGoalModificationLC;

        // extracted operaters for filtering claimed tasks
        filterUsers;

        // loading panel indicator
        loading = false;

        static $inject = ["appTrackerApi", "generalService", "identityService"]
        constructor(private apt: services.AppTrackerApi,
            private gs: services.GeneralService, private ids: services.IdentityService) {
        }

        onTabSelected(tabInd: number) {
            if (this.selTab !== tabInd) {
                this.selTab = tabInd;
                if (tabInd === 1) { // NEW ACC
                    this.loadNewAccountLifeCycle(this.newAccLcArchivedOnly);
                } else if (tabInd == 2) { // GOAL MODIF
                    this.loadGoalModificationLifeCycle(this.goalModifLcArchivedOnly);
                }
            }
        }

        loadNewAccountLifeCycle(showArchivedOnly: boolean) {
            this.loading = true;
            this.apt.getAppTrackerData(services.AppTrackerApi.LIFECYCLE_NEW_ACCOUNT, showArchivedOnly, this.filterByAdvisor, this.includeProposedAmount)
                .then(
                    resp => {
                        this.newAccountLC = resp.data;
                        this.extractUserFilter(this.newAccountLC);
                        // apply first filter
                        var filtered = this.filterWorkflowsByStatus(this.filterUnclaimedNewAcc, this.newAccountLC);
                        // apply second filter
                        this.filteredNewAccountLC = this.filterWorkflowsByUser(this.selUser, filtered);
                },
                err => this.gs.showError(err))
                .finally(() => this.loading = false);
        }

        loadGoalModificationLifeCycle(showArchivedOnly: boolean) {
            this.loading = true;
            this.apt.getAppTrackerData(services.AppTrackerApi.LIFECYCLE_GOAL_MODIFICATION, showArchivedOnly, this.filterByAdvisor, this.includeProposedAmount)
                .then(
                resp => {
                    this.goalModificationLC = resp.data;
                    this.filteredGoalModificationLC = this.filterWorkflowsByStatus(this.filterUnclaimedGoalModified, this.goalModificationLC);
                },
                    err => this.gs.showError(err))
                .finally(() => this.loading = false);
        }

        onFilterByUser() {
            var filtered = this.filterWorkflowsByStatus(this.filterUnclaimedNewAcc, this.newAccountLC);
            this.filteredNewAccountLC = this.filterWorkflowsByUser(this.selUser, filtered);
        }
        
        onChangeGoalModifLcArchivedOnly() {
            //console.log(`Show archived for Goal Modified LC: ${this.goalModifLcArchivedOnly}`);
            this.loadGoalModificationLifeCycle(this.goalModifLcArchivedOnly);
        }

        onChangeNewAccLcArchivedOnly() {
            //console.log(`Show archived for New Account LC: ${this.newAccLcArchivedOnly}`);
            this.loadNewAccountLifeCycle(this.newAccLcArchivedOnly);
        }

        onChangeGoalModifLcFilter() {
            //console.log(`Show archived for Goal Modified LC: ${this.filterUnclaimedGoalModified}`);
            this.loadGoalModificationLifeCycle(this.goalModifLcArchivedOnly);
        }

        onChangeNewAccLcFilter() {
            var filtered = this.filterWorkflowsByStatus(this.filterUnclaimedNewAcc, this.newAccountLC);
            this.filteredNewAccountLC = this.filterWorkflowsByUser(this.selUser, filtered);
        }

        // An account that has finished its workflow is off the App Tracker. Drop it from the
        // lists the filters are rebuilt from, or it comes back the moment a filter is toggled.
        onAccountLeftTracker(accountId: number) {
            this.removeAccountFrom(this.newAccountLC, accountId);
            this.removeAccountFrom(this.filteredNewAccountLC, accountId);
            this.removeAccountFrom(this.goalModificationLC, accountId);
            this.removeAccountFrom(this.filteredGoalModificationLC, accountId);
        }

        removeAccountFrom(workflows: domains.IAppTrackerData[], accountId: number) {
            if (!workflows) {
                return;
            }

            // the grid may already have dropped it from a list it shares with us
            const ind = workflows.findIndex(w => w.accountId === accountId);
            if (ind >= 0) {
                workflows.splice(ind, 1);
            }
        }

        filterWorkflowsByStatus(showUnclaimedOnly: boolean, workflows: domains.IAppTrackerData[]): domains.IAppTrackerData[] {
            if (!showUnclaimedOnly) {
                return workflows;
            }

            return workflows
                .filter(workflow => workflow.activities
                    .every(activity => activity.activityStatus != domains.LifeCycleActivityStatus.CLAIMED));
        }

        filterWorkflowsByUser(filterByUser: string, workflows: domains.IAppTrackerData[]) {
            if (!filterByUser) {
                return workflows;
            } else {
                return workflows
                    .filter(f => f.activities
                        .some(s => s.responsibleUserId === this.selUser &&
                            s.activityStatus == domains.LifeCycleActivityStatus.CLAIMED));
            }
        }

        extractUserFilter(workflows: domains.IAppTrackerData[]) {

            const servicer = {};

            servicer[this.user.id] = { id: this.user.id, name: `${this.user.firstName} ${this.user.lastName}` };

            const claimedTasks = workflows.forEach(wf => {
                wf.activities.filter(act => act.activityStatus === domains.LifeCycleActivityStatus.CLAIMED).forEach(act => {
                    servicer[act.responsibleUserId] = { id: act.responsibleUserId, name: act.responsibleUserName };
                });
            });

            //console.log(servicer);

            this.filterUsers = servicer;
        } 

        $onInit(): void {

            this.user = this.ids.getUser();

            if (this.user.role === "ADVISORY"
                || this.user.role === "ADVISORY_LEAD"
                || this.user.role === "ADVISORY_ADMIN")
                this.dashboardLabel = "Advisor";
            else
                this.dashboardLabel = "Servicer";

            //we have to select first tab
            this.onTabSelected(1);
        }

        $onChanges(evt): void {
        }
    }

    class ApplicationTrackerMain implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                filterByAdvisor: "<",
                includeProposedAmount: "<",
            };
            this.controller = ApplicationTrackerMainController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/application-tracker-main.html';
        }
    }
    angular.module(Constants.APP).component("applicationTrackerMain", new ApplicationTrackerMain());
}
